module.exports = __webpack_public_path__ + "img/poster-3.a1db1e20.jpg";